import { ViewStackEventType } from '../enums/view-stack-event-type.enum';
import { ViewStackItem } from './view-stack-item';

export class ViewStackEvent {
  public constructor(public type: ViewStackEventType, public component?: ViewStackItem) {
  }
}
